module.exports = __webpack_public_path__ + "media/images/river/shirt-carousel/shirt-3-a762f1060aa6ccfadac353a7c556ced9.jpg";